import { Box, Divider, Stack } from "@mui/material";
import { ScreenerFinish, ScreeningHeader } from "./ScreeningHeader";
import AdminLockedAlert from "./AdminLockedAlert";
import QuestionItemWrapper from "../Responses/QuestionItemWrapper";
import ConfirmationModalWrapper from "../Responses/ConfirmationModalWrapper";
import CalculationWrapper from "../Responses/CalculationWrapper/CalculationWrapper";
import { useAppSelector } from "../../Redux/hooks";

const ScreeningAttempt = ({
  languages,
  refreshPage,
}: {
  languages: any;
  refreshPage: () => void;
}) => {
  const editable = useAppSelector((state) => state.response.editable);
  const isAdminAttempted = useAppSelector(
    (state) => state.response.isAdminAttempted,
  );
  const showAdminLocked = !editable && isAdminAttempted;

  return (
    <Stack sx={{ height: "100vh", overflow: "hidden" }}>
      <Box sx={{ flexShrink: 0 }}>
        <ScreeningHeader
          languages={languages}
          refreshPage={refreshPage}
        />
        <Divider />
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          p: 2,
        }}
      >
        <AdminLockedAlert />
        <QuestionItemWrapper />
        {!showAdminLocked && (
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <ScreenerFinish refreshPage={refreshPage} />
          </Box>
        )}
      </Box>

      <ConfirmationModalWrapper />
      <CalculationWrapper />
    </Stack>
  );
};
export default ScreeningAttempt;
